// ─── Menu webu ────────────────────────────────────────────────────────────
// Odkazy v horní liště, v mobilním menu i na úvodní fotce se berou odsud,
// takže se nemůže stát, že by někde vedly na sekci, která na stránce není.

import { CHRISTMAS_SECTION_ID, isChristmasActive } from './christmas';

/**
 * Sekce Časté dotazy – zapnout (true), až budou otázky a odpovědi finální
 * (texty jsou v src/components/FAQ.tsx). Jedním přepínačem se ukáže sekce
 * na stránce i odkaz DOTAZY v menu.
 */
// Anotace boolean: je to přepínač – s typem „false“ by TypeScript bral
// podmínky s ním jako vždy nepravdivé
export const SHOW_FAQ: boolean = false;

export interface NavLink {
  href: string;
  label: string;
}

/** Odkazy v pořadí, v jakém jdou sekce na stránce. */
export function getNavLinks(): NavLink[] {
  const links: NavLink[] = [];

  // Vánoční focení jen do konce akce (pak zmizí i sekce – viz christmas.ts)
  if (isChristmasActive()) {
    links.push({ href: `#${CHRISTMAS_SECTION_ID}`, label: 'VÁNOCE' });
  }

  links.push(
    { href: '#portfolio', label: 'PORTFOLIO' },
    { href: '#about', label: 'O MNĚ' },
    { href: '#pricing', label: 'CENÍK' }
  );

  if (SHOW_FAQ) {
    links.push({ href: '#faq', label: 'DOTAZY' });
  }

  links.push({ href: '#contact', label: 'KONTAKT' });

  return links;
}
